import { render, staticRenderFns } from "./cityList.vue?vue&type=template&id=55f56668&scoped=true"
import script from "./cityList.vue?vue&type=script&lang=js"
export * from "./cityList.vue?vue&type=script&lang=js"
import style0 from "./cityList.vue?vue&type=style&index=0&id=55f56668&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f56668",
  null
  
)

export default component.exports